export default __webpack_public_path__ + "static/media/chelsi.66c6b142.jpeg";